import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import formatUrlSearchParameters from '@/libraries/formatters/format-url-search-parameters';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryTermsAndConditionsData =
  Content.Components['TermsAndConditionsModuleDto'];

interface UseQueryTermsAndConditionsOptions {
  enabled?: boolean;
  initialData?: UseQueryTermsAndConditionsData;
  parameters: Content.Components['IBookingHeadlessParameters'] & {
    id: string;
    pageId: string;
  };
}

const useQueryTermsAndConditions = ({
  enabled = true,
  initialData,
  parameters,
}: UseQueryTermsAndConditionsOptions) => {
  const locale = getLocale();

  const query = useQuery<UseQueryTermsAndConditionsData>(
    [QueryId.TERMS_AND_CONDITIONS, parameters, locale],
    async () => {
      const baseUrl = '/api/content-modules/terms-and-conditions';
      const queryParameters = formatUrlSearchParameters(parameters);

      const fetchResponse = await fetch(
        `${baseUrl}?${queryParameters.toString()}`,
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQueryTermsAndConditions', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters && enabled,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryTermsAndConditions;
